// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  location: {
    search: string
  }
};

type State = {
  email: string
};
class ScreenAcceptInvite extends React.PureComponent<Props, State> {
  state = {
    email: ''
  };

  componentDidMount() {
    const email = localStorage.getItem('accept_invite_user_email') || '';
    this.setState({ email });
  }

  render() {
    return (
      <div className="accept-invite-container">
        <div className="accept-invite-header">
          <img
            className="branch-logo"
            src="/static/images/branch-logos/branch-logo_dark.svg"
          />
        </div>
        <div>
          <div>
            <h1
              className="verify-email"
              data-testid="verify-email--header-title"
            >
              Check your Email
            </h1>
          </div>
          <div data-testid="verify-email--header-image">
            <img
              className="accept-image"
              src="https://res.cloudinary.com/dzeo8q4va/image/upload/v1577428920/img_emailSent.png"
            />
          </div>
          <p className="email-instructions">
            Before you start using Branch, we need you to verify your email
            address. An email containing verification instructions was sent to{' '}
            <b data-testid="verify-email--user-email">{this.state.email}</b>.
            with a link to verify your account.
            <br></br>
            <br></br>
            Didn't get the email? Check your spam folder or{' '}
            <Link
              to="/resend-verification-email"
              data-testid="verify-email--link-resend"
            >
              {' '}
              <b>Resend</b>{' '}
            </Link>{' '}
            verification email.
          </p>
          <p className="email-footer">
            Incorrect email address?{' '}
            <Link to="/" data-testid="verify-email--link-signup">
              {' '}
              <b>Sign Up</b>{' '}
            </Link>{' '}
            to start over.
          </p>
        </div>
      </div>
    );
  }
}

export default ScreenAcceptInvite;
